import { Typography } from 'antd';

import AccountDescriptions from './AccountDescriptions';
import EarlySpendBonus from './EarlySpendBonus';
import RewardsRate from './RewardsRate';

const { Text } = Typography;

const RewardsDescriptions = ({ rewards, rewardsFailure }) => {
  const items = [];

  if (rewardsFailure) {
    items.push({
      key: 1,
      span: 2,
      label: 'Rewards Rate',
      children: <Text type="danger">Failed to retrieve</Text>,
    });
  } else if (rewards) {
    const { rewardsConfig, rewardsPayable } = rewards;

    if (rewardsConfig?.rewardsRate) {
      items.push({
        key: 1,
        span: 2,
        label: 'Rewards Rate',
        children: <RewardsRate rewards={rewards} />,
      });
    }

    // esb net spend is hardcoded, check for valid esb amount and date for valid esb offer
    if (rewardsConfig?.esbAmount && rewardsConfig?.esbRewardDate) {
      items.push({
        key: 2,
        span: 2,
        label: 'Early Spend Bonus',
        children: <EarlySpendBonus rewards={rewards} />,
      });
    }

    if (rewardsPayable) {
      const pendingAmount = rewardsPayable?.amount;
      const twelveMonthRewardsEarned = rewardsPayable?.twelveMonthRewardsEarned;

      items.push({
        key: 3,
        span: 2,
        label: 'Earned Rewards',
        children: (
          <>
            {!isNaN(pendingAmount) ? (
              <div data-testid="pending-rewards">
                {pendingAmount > 0
                  ? `Pending: $${pendingAmount.toFixed(2)}`
                  : 'No Pending Rewards'}
              </div>
            ) : null}
            {!isNaN(twelveMonthRewardsEarned) ? (
              <div data-testid="twelve-month-rewards">
                {twelveMonthRewardsEarned > 0
                  ? `12-Month Rewards Earned: $${twelveMonthRewardsEarned.toFixed(2)}`
                  : 'No Earned Rewards'}
              </div>
            ) : null}
          </>
        ),
      });
    }
  }

  if (items.length === 0) {
    return null;
  }

  return <AccountDescriptions title="Rewards" items={items} />;
};

export default RewardsDescriptions;
